import { GenericGridSmartViewsWebComponent } from './component/GenericGridSmartViewsWebComponent';
import { WEB_COMPONENT_GENERIC_GRID_SMART_VIEWS } from '../../webcomponents.constants';

export { GenericGridSmartViewsWebComponent };

window.customElements.define(WEB_COMPONENT_GENERIC_GRID_SMART_VIEWS, GenericGridSmartViewsWebComponent);
